"use strict";

import axios from "axios";
import { store } from "@/store";
import app from "@/main";
import { getApiBaseUrl } from "@/_helpers";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let isRefreshing = false;
let refreshSubscribers = [];

let config = {
  baseURL: "",
  withCredentials: false,
};

/**
 * The requests which fail while the Token is not refresh, must be stored on this list.
 * After the Token is successfully refreshed the requests stored on the list are evoked again with the new Token.
 * @param cb
 */
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

/**
 * This is the function called after receiving a new Access Token.
 * Using the new Token the failed requests are evoked again.
 * At the end, the requests stored on the list refreshSubscribers are cleaned.
 * @param token
 */
function onRefreshed(token) {
  app.$log.debug("Pending Requests List Size: ", refreshSubscribers.length);
  refreshSubscribers.map((cb) => cb(token));
  refreshSubscribers.length = 0;
}

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response errors
    const {
      config,
      response: { status },
    } = error;
    const originalRequest = config;

    // @modified ana.castro 2019.09.24 SCLAPP-20
    app.$log.debug("ERROR: REQUEST FAILED | Request: ", config);
    app.$log.debug("ERROR: REQUEST FAILED | Status: ", status);

    // An interceptor in place to catch 401 errors if the access token expires
    if (
      status === 401 &&
      !config["url"].endsWith("rest-auth/refresh_token/") &&
      !config["url"].endsWith("rest-auth/obtain_token/") &&
      !config["url"].endsWith("rest-auth/obtain-token/")
    ) {
      if (!isRefreshing) {
        isRefreshing = true;
        //  If the Token expires it tries the refresh token to get a new access token.
        //  If any other calls are made during this time they are queued (subscribeTokenRefresh)
        //  until the access token is validated.
        // Once the access token has been refreshed the queue of requests is processed
        store.dispatch("authentication/refreshToken").then((newToken) => {
          isRefreshing = false;
          onRefreshed(newToken);
        });
      }

      // eslint-disable-next-line
      const retryOrigReq = new Promise((resolve, reject) => {
        subscribeTokenRefresh((token) => {
          // Replace the expired token and retry
          originalRequest.headers["Authorization"] = "JWT " + token;
          resolve(axios(originalRequest));
        });
      });
      return retryOrigReq;
    } else {
      return Promise.reject(error);
    }
  }
);

export function setAxiosDefaultHeaders() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.access) {
    _axios.defaults.headers["Authorization"] = "JWT " + user.access;
  } else {
    delete _axios.defaults.headers["Authorization"];
  }
}

export function setAxiosDefaultUrl() {
  _axios.defaults.baseURL = getApiBaseUrl();
}

setAxiosDefaultHeaders();
export { _axios };
